import request from "root/js/request";
import { getPreviousFullWeekDates, getServerDate } from "root/utils/date";

export const getWBDynamicKeywordsStatByIDWeeklyDynamic = async ({
  keyword_id,
  date_from,
  date_to,
  predict_trend,
  predict_trand = predict_trend,
  period,
  ...rest
}) => {
  // Эта логика важна при получении предсказаний по неделям. Если не ограничить даты на конец предыдущей недели
  // то прогноз построится с учётом дней текущей, тк keywords_stat хранит данные по дням, а weekly_dynamic
  // просто группирует их по неделям
  const correctEndDate = getServerDate("2025-09-15");
  // Неверная логика ниже и вообще почему это происходит в запросе, в корне неверно, надо исправить
  // predict_trand && !date_to ? getServerDate((getPreviousFullWeekDates() || [])[1]) : date_to;
  //
  const response = await request({
    url: `/wb_dynamic/keywords_stat/${keyword_id}/weekly_dynamic/`,
    method: "get",
    params: {
      date_from,
      //
      date_to: correctEndDate,
      //
      predict_trand,
      period,
      ...rest,
    },
  });
  return response.data;
};
